export default {
    title: 'Pesquisa do item de cobrança',
    labels: {
        search: 'Pesquise por nome ou código do item de cobrança',
        searchDocuments: 'Pesquisar por código, nome ou tipo de documento',
        results: 'Resultados',
        configurations: 'Configurações do item de cobrança',
        addConfiguration: 'Adicionar configuração',
        deleteConfiguration: 'Tem certeza que deseja excluir as configurações do item de cobrança?',
        cannotRevert: 'Esta ação não pode ser revertida',
        agreementsTitle: 'Convênios',
        servicesTitle: 'Serviços',
        supportsTitle: 'Documentos',
        searchAlert: 'Você deve inserir um nome ou código do item de cobrança',
    },
    headers: {
        code: 'Código',
        name: 'Nome',
        services: 'Serviços',
        agreementCodes: 'Códigos de convênios',
        supportsRequired: 'Documentos necessários',
        actions: 'Ações',
    },
    detail: {
        title: 'Configuração dos itens de cobrança {code}',
        agreements: 'Convênios impactados',
        addAgreement: 'Adicionar convênio',
        services: 'Serviços impactados',
        addService: 'Adicionar serviço',
        supports: 'Documentos impactados',
        addSupport: 'Adicionar documentos',
        updateSuccess: 'Configuração dos itens de cobrança atualizada com sucesso',
        updateError: 'Erro ao atualizar a Configuração dos itens de cobrança',
        searchAgreement: 'Pesquisar por código do convênio',
        searchSupports: 'Pesqisar por código, nome ou tipo de documento',
        productHeaders: {
            code: 'Código',
            name: 'Nome do item de cobrança',
            agreementCode: 'Código do convênio',
        },
        agreementHeaders: {
            code: 'Código',
            payer: 'Operadora',
            serviceTypes: 'Tipos de serviço',
            actions: 'Ações',
        },
        serviceHeaders: {
            code: 'Código do serviço',
            name: 'Nome do Serviço',
            actions: 'Ações',
        },
        supportHeaders: {
            code: 'Código do documento',
            name: 'Nome do documento',
            type: 'Tipo de documento',
            actions: 'Ações',
            required: 'Obrigatório',
        },
    }
}